module.exports = __webpack_public_path__ + "img/knowledge-base-cover.76a102a1.jpg";